import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useConfig } from "../../config";
import { Resizable } from "re-resizable";

const RightPanel = ({
  editor,
  children,
  isOpen,
  onClose,
  setPanelValue,
  setPanelOpen,
  panelValue,
  setMetaValue,
}) => {
  const { queryLength, referenceLength } = useSelector((state) => state.editor);
  const { config } = useConfig();
  const [isResizing, setIsResizing] = useState(false);
  const [width, setWidth] = useState(isOpen ? 370 : 0);

  // Update width whenever showNavBar changes
  useEffect(() => {
    if (!isResizing) {
      setWidth(isOpen ? 370 : 0); // force width update
    }
  }, [isOpen, isResizing]);

  const BanelButtons = [
    {
      name: "MetaData",
      value: "meta",
      length: null,
    },
    {
      name: "Query",
      value: "query",
      length: queryLength ?? 0,
    },
    {
      name: "Reference",
      value: "ref",
      length: referenceLength ?? 0,
    },
    {
      name: "View PDF",
      value: "pdf",
      length: null,
    },
  ];

  const handlePanelClick = (item) => {
    setPanelValue(item.value);
    if (!isOpen) {
      setPanelOpen((prev) => !prev);
    } else if (panelValue === item.value) {
      setPanelOpen((prev) => !prev);
      setMetaValue(null);
      setPanelValue(null);
    }
  };
  useEffect(() => {
    if (isOpen) {
      if (panelValue === "pdf") {
        setWidth(window.innerWidth * 0.5);
      } else {
        setWidth(370);
      }
    }
  }, [isOpen, panelValue]);

  // const buttonRefs = useRef([]);
  // const wrapperRefs = useRef([]);
  // useEffect(() => {
  //   // Loop over all buttons
  //   buttonRefs.current.forEach((btn, index) => {
  //     if (btn && wrapperRefs.current[index]) {
  //       const originalWidth = btn.offsetWidth; // Get button's unrotated width
  //       wrapperRefs.current[index].style.height = `${originalWidth + 20}px`;
  //     }
  //   });
  // }, [config]);

  return (
    <Resizable
      size={{ width, height: "100%" }}
      minWidth={
        isOpen ? (config.RightPanel ? 340 : 340) : config.RightPanel ? 40 : 0
      }
      maxWidth={window.innerWidth * 0.6}
      style={{
        transition: "all 0.3s linear", // smooth width transition
        overflow: "hidden",
        marginTop:"0"
      }}
      enable={{ top: false, right: false, bottom: false, left: isOpen }}
      onResizeStop={(e, direction, ref) => {
        setIsResizing(false);
        setWidth(ref.offsetWidth); // update width after manual drag
      }}
    >
      <div
        className={`h-full right-panel  shadow-lg transition-all duration-500 linear bg-leftPanelbg flex opacity-100
        `}
      >
        <div
          className={`${isOpen ? "flex relative flex-col" : "hidden"} ${
            config.RightPanel ? "mr-[40px]" : ""
          } h-full gap-5 w-full transition-all duration-500 linear`}
        >
          <div className="w-full h-full flex flex-col p-3 gap-5 right-panel-scroll overflow-auto mb-5">
            {children}
          </div>
          {!config.RightPanel && (
            <button
              onClick={onClose}
              className="mt-auto w-full bg-[#0060CE] rounded-[8px] text-white py-2"
            >
              Close
            </button>
          )}
        </div>

        {config.RightPanel && (
          <div className="absolute inset-y-0 top-0 bottom-0 rightpanel-btn h-full  -right-[4px] w-[44px] flex flex-col  justify-start gap-3 overflow-hidden bg-white pt-20">
            {BanelButtons.map((item, i) => (
              <button
                key={i}
                onClick={() => handlePanelClick(item)}
                className={`
                 flex items-center gap-2 justify-center
                 px-2 py-2 border rounded-[8px]
                 font-medium whitespace-nowrap ml-1
                 ${
                   panelValue === item.value
                     ? "bg-hovergrey text-white"
                     : "bg-white text-primary"
                 }
               `}
                style={{
                  writingMode: "vertical-lr",
                  textOrientation: "mixed",
                  transform: "rotate(180deg)",
                }}
              >
                {item.name}
                {item.length !== null && (
                  <span className={`rounded-full px-[4px] py-[6px]   text-xs  ${
                   panelValue === item.value
                     ? "bg-white text-primary"
                     : "bg-primary text-white"
                 }`}>
                    {item.length}
                  </span>
                )}
              </button>
            ))}
          </div>
        )}
      </div>
    </Resizable>
  );
};

export default RightPanel;
